export default __webpack_public_path__ + "static/media/q11.12f82f2f.png";